import React, { useEffect, useState } from "react";
import Sidebar from "../../Common/Sidebar";
import EmployerLayout from "./Common/EmployerLayout";
import { useNavigate } from "react-router-dom";
import NoSubscriptionAlert from "./NoSubscriptionAlert";
import { GetUserSubscriptions } from "../../../Redux/Slices/Package";
import { BeatLoader } from "react-spinners";
import "../../../asset/new/css/employer-modern.css";

const CvAccess = () => {
  const navigate = useNavigate();
  const [salesHistory, setSalesHistory] = useState(null);

  const salesHistoryHandler = async () => {
    let data = await GetUserSubscriptions();
    setSalesHistory(data?.subscriptions);
  };
  useEffect(() => {
    salesHistoryHandler();
  }, []);
  useEffect(() => {
    document.title = "Cv Access | CAJobPortal";
    let data = salesHistory?.filter(
      (item) =>item?.avail_cvsearch > 0
    )?.length;
    if (data) {
      navigate("/employer/candidatesearch");
    }
  }, [salesHistory]);
  return (
    <div className="employer-layout">
      <Sidebar />
      <EmployerLayout breadcrumbs={['Employer', 'CV Access']}>
        <div className="employer-page-header">
          <h1 className="employer-page-title">CV Access</h1>
        </div>

        {!salesHistory ? (
          <div className="employer-loading-overlay" style={{ position: 'relative', padding: '3rem' }}>
            <BeatLoader color="#4893B3" size={15} />
          </div>
        ) : (
          <NoSubscriptionAlert salesHistory={salesHistory} />
        )}
      </EmployerLayout>
    </div>
  );
};

export default CvAccess;
